
<template>
  <div :dir="$i18n.locale === 'ar' ? 'rtl' : 'ltr'">
    <NuxtRouteAnnouncer />
    <NuxtLayout>
      <NuxtPage />
    </NuxtLayout>
    <CookiesToast />
    <PrimeToast style="top: 60px; max-width: 90vw" />
    <PrimeDialog :visible="showNeedLogin" @update:visible="onDialogVisibilityChange" modal :header="$t('components.auth.loginRequired')" :style="{ width: '25rem' }">
        <div class="flex flex-col items-center gap-4 mb-4">
          <p class="text-center">{{ $t('components.auth.needLoginMessage') }}</p>
          <div class="flex gap-3 mt-4">
            <PrimeButton @click="navigateToLogin" :label="$t('components.auth.signIn')" severity="contrast" />
            <PrimeButton @click="navigateToRegister" :label="$t('components.auth.signUp')" />
          </div>
        </div>
    </PrimeDialog>
  </div>
</template>

<script>
import { mapState } from 'pinia';
import { useAuthStore } from '~/stores/AuthStore';
import CookiesToast from '~/components/global/CookiesToast.vue';

export default {
  name: 'App',
  components: {
    CookiesToast
  },
  computed: {
    ...mapState(useAuthStore, ['showNeedLogin'])
  },
  methods: {
    onDialogVisibilityChange(value) {
      const authStore = useAuthStore();
      if (!value) {
        authStore.setShowNeedLogin(false);
      }
    },
    navigateToLogin() {
      const authStore = useAuthStore();
      authStore.setShowNeedLogin(false);
      const router = useRouter();
      const localePath = useLocalePath();
      router.push(localePath('/login'));
    },
    navigateToRegister() {
      const authStore = useAuthStore();
      authStore.setShowNeedLogin(false);
      const router = useRouter();
      const localePath = useLocalePath();
      router.push(localePath('/register'));
    }
  }

}
</script>

<style>

</style>
